import i18n from '@/i18n/i18n'
import RegionService from '@/services/admin/RegionService.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  regions: [],
  region: {}
}

export const mutations = {
  SET_REGIONS(state, regions) {
    state.regions = regions.data
  },
  SET_REGION(state, region) {
    state.region = region
  }
}
export const getters = {
  getRegionById: state => id => {
    return state.regions ? state.regions.find(region => region.id === id) : false
  }
}

export const actions = {
  getRegions({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      RegionService.getRegions()
        .then(response => {
          commit('SET_REGIONS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: t('store.admin.region.get_regions_error') + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRegion({ commit, state, getters }, id) {
    if (id === state.region.id) return state.region
    let region = getters.getRegionById(id)
    if (region) {
      commit('SET_REGION', region)
      return region
    } else {
      return new Promise(resolve => {
        RegionService.getRegion(id).then(response => {
          commit('SET_REGION', response.data)
          resolve(response.data)
        })
      })
    }
  }
}
